module.exports = __webpack_require__.p + "5f3a322e319747ad220e2f42d35f2901.jpg";